import { useMediaQuery } from 'react-responsive';

const size = {
  tabletAndBelow: '767px',
  desktop: '768px',
};

export const device = {
  tabletAndBelow: `(max-width: ${size.tabletAndBelow})`,
  desktop: `(min-width: ${size.desktop})`,
};

export const useMedia = () => {
  return {
    isDesktop: useMediaQuery({ query: `${device.desktop}` }),
    isTabletAndBelow: useMediaQuery({ query: `${device.tabletAndBelow}` }),
  };
};

const Desktop = ({ children }: { children: JSX.Element }) => {
  const { isDesktop } = useMedia();

  return isDesktop ? children : null;
};

const TabletAndBelow = ({ children }: { children: JSX.Element }) => {
  const { isTabletAndBelow } = useMedia();

  return isTabletAndBelow ? children : null;
};

export { Desktop, TabletAndBelow };
